// 借款功能 （中）
module.exports = {
    top: {
        name1: '中二年'
    }
}